import { applyMiddleware, createStore } from 'redux'
import { createLogger } from 'redux-logger'
import thunkMiddleware from 'redux-thunk'

import { cablecarActions } from '../middleware/cablecar_actions'

const configureStore = (rootReducer, preloadedState, otherMiddleware = []) => {
  const middleware = [
    thunkMiddleware, // lets us dispatch() functions
    cablecarActions, // pre-process cableCar actions to have correct object structure
    ...otherMiddleware,
  ]

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-line
    const reduxLogger = createLogger({
      collapsed: true,
      colors: {
        title: (action) =>
          action.meta?.__cablecar__ &&
          (action.subsidiaryStoreId ? '#13a5ff' : '#2bff13'),
        prevState: (prevState) => prevState.isRootStore && '#e4b639',
        nextState: (nextState) => nextState.isRootStore && '#e4b639',
      },
    })
    middleware.push(reduxLogger)
  }

  return createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(...middleware),
  )
}

export default configureStore
